import { diaryHomeToDoPath } from "@/features/diaries/routes";
import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy URL - redirects to the To Do tab. */
export const Route = createFileRoute("/_app/diaries/$diaryId/home/forms")({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: diaryHomeToDoPath,
            params: { diaryId: params.diaryId },
        });
    },
});
